import MetadataService from '../../../../../../services/MetadataService'

function getOrgAndProjectFromUrl() {
  const parts = window.location.pathname.split('/')
  const org = parts[1]
  const project = parts[2]
  return { org, project }
}

export function getKeyMetadata(key) {
  const { org, project } = getOrgAndProjectFromUrl()
  if (!org || !project) throw new Error('Missing org or project in URL')
  return MetadataService.getKeyMetadata(org, project, key)
}
